module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/spices@3x_5b8d22.jpg";